import { useState } from 'react'
import { Button } from './ui/button'
import { Icon } from './ui/icon'

export default function Sidebar({ children }: { children: React.ReactNode }) {
	const [open, setOpen] = useState<boolean>(false)
	return (
		<>
			<nav
				className={`
        fixed top-0 z-10 min-h-screen w-4/5 shrink-0 grow-0 basis-1/4 overflow-auto bg-primary-foreground p-2 pb-20 pt-[4.5rem] transition-transform
        md:static md:min-h-[calc(100vh-4rem)] md:max-w-72 md:translate-x-0 md:border-r-0 md:pt-2 md:shadow-none
        ${open ? 'translate-x-0 border-r border-r-border' : '-translate-x-full'}
      `}
			>
				<>{children}</>
			</nav>
			<Button
				onClick={() => setOpen(!open)}
				size="icon"
				variant={'outline'}
				className="fixed bottom-4 left-4 z-30 p-1 text-h5 shadow-lg md:hidden"
			>
				<Icon name="magnifying-glass" size="font" />
			</Button>
		</>
	)
}
